import request from "../utils/request"

/**
 * 测试动态生成路由
 */
export function generateRoutes() {
    return request({
        url: '/adminapi/parameter/ruoters',
        method: 'GET',
    })
}

export function getUserInfo() {
    return request({
        url: '/adminapi/parameter/query',
        method: 'GET',
    })
}

export function getNodest() {
    return request({
        url: '/adminapi/parameter/nodest',
        method: 'GET',
    })
}

// 购物车列表
export function commodity_list(jqcode) {
    const params = {
        jqcode
    }
    return request({
        url: '/adminapi/parameter/commodity_list',
        method: 'get',
        params
    })
}

// 物品条件查询
export function seek(hunt) {
    return request({
        url: '/adminapi/parameter/hunt',
        method: 'post',
        data: hunt
    })
}

// 登录
export function login(enter) {
    return request({
        url: '/adminapi/Login',
        method: 'post',
        data: enter
    })
}

/**
 * 用户登出
 */
export function outLogin() {
    return request({
        url: '/adminapi/outLogin',
        method: 'post',
    })
}

// 判断用户登录是否过期
export function checkToken() {
    return request({
        url: '/adminapi/checkToken',
        method: 'get'
    })
}

// 首页数据详情
export function introduce() {
    return request({
        url: '/adminapi/introduce',
        method: 'get'
    })
}

// 首页图标数据
export function report_form() {
    return request({
        url: '/adminapi/api/index/report_form',
        method: 'get',
    })
}

export function salesTrend(date) {
    return request({
        url: '/adminapi/salesTrend',
        method: 'post',
        data: date
    })
}

// 机器销售额排名
export function machineSalesRanking(date) {
    return request({
        url: '/adminapi/machineSalesRanking',
        method: 'post',
        data: date
    })
}

// 物品销售额排名
export function productSalesRanking(date) {
    return request({
        url: '/adminapi/productSalesRanking',
        method: "post",
        data: date
    })
}

// 用户列表
export function userIndex(date) {
    return request({
        url: '/adminapi/userIndex',
        method: 'post',
        data: date
    })
}

// 用户编辑获取详情
export function getAdminDetail(date) {
    return request({
        url: '/adminapi/getAdminDetail',
        method: 'post',
        data: date
    })
}

// 保存用户编辑
export function saveAdmin(date) {
    return request({
        url: '/adminapi/saveAdmin',
        method: 'post',
        data: date
    })
}

// 删除用户数据
export function delAdmin(date) {
    return request({
        url: '/adminapi/delAdmin',
        method: 'post',
        data: date
    })
}

// 导出用户列表
export function daoAdmin(rows) {
    return request({
        url: '/adminapi/daoAdmin',
        method: 'post',
        data: rows
    })
}

// 用户类型列表
export function roleIndex(date) {
    return request({
        url: '/adminapi/roleIndex',
        method: 'post',
        data: date
    })
}

// 编辑用户类型获取详情
export function getRoleDetail(date) {
    return request({
        url: '/adminapi/getRoleDetail',
        method: 'post',
        data: date
    })
}

// 用户类型编辑保存
export function saveRole(date) {
    return request({
        url: '/adminapi/saveRole',
        method: 'post',
        data: date
    })
}

// 删除用户类型
export function delRole(date) {
    return request({
        url: '/adminapi/delRole',
        method: 'post',
        data: date
    })
}

// 权限
export function authList(date) {
    return request({
        url: '/adminapi/authList',
        method: 'post',
        data: date
    })
}

// 修改权限
export function saveAuth(date) {
    return request({
        url: '/adminapi/saveAuth',
        method: 'post',
        data: date
    })
}

// 功能列表
export function functionList() {
    return request({
        url: '/adminapi/functionList',
        method: 'post',
    })
}

// 获取用户信息动态生成路由
export function functionListMe() {
    return request({
        url: '/adminapi/functionListMe',
        method: 'post'
    })
}

export function getFunctionDetail(date) {
    return request({
        url: '/adminapi/getFunctionDetail',
        method: 'post',
        data: date
    })
}

// 保存功能列表编辑
export function saveFunction(date) {
    return request({
        url: '/adminapi/saveFunction',
        method: 'post',
        data: date
    })
}

// 删除列表功能
export function delFunction(date) {
    return request({
        url: '/adminapi/delFunction',
        method: 'post',
        data: date
    })
}

// 新录功能
export function getFunctionName() {
    return request({
        url: '/adminapi/getFunctionName',
        method: 'post'
    })
}

// 保存新新录功能
export function addFunction(date) {
    return request({
        url: '/adminapi/addFunction',
        method: 'post',
        data: date
    })
}

// 个人中心
export function infoIndex() {
    return request({
        url: '/adminapi/infoIndex',
        method: 'post'
    })
}

// 用户信息修改
export function infomationSave(date) {
    return request({
        url: '/adminapi/infomationSave',
        method: 'post',
        data: date
    })
}

// 修改用户密码
export function passwordSave(date) {
    return request({
        url: '/adminapi/passwordSave',
        method: 'post',
        data: date
    })
}

// 获取短信验证码
export function sendSms(date) {
    return request({
        url: '/adminapi/sendSms',
        method: 'post',
        data: date
    })
}

// 修改用户手机号
export function mobileSave(date) {
    return request({
        url: '/adminapi/mobileSave',
        method: 'post',
        data: date
    })
}

// 入库列表
export function inStockIndex(date) {
    return request({
        url: '/adminapi/warehousingIndex',
        method: 'post',
        data: date
    })
}

export function allWarehouse() {
    return request({
        url: '/adminapi/allWarehouse',
        method: 'get'
    })
}

export function getWarehouseDetails(date) {
    return request({
        url: '/adminapi/getWarehouseDetails',
        method: 'post',
        data: date
    })
}

export function getAllProductName(date) {
    return request({
        url: '/adminapi/getAllProductName',
        method: 'post',
        data: date
    })
}

export function getAllProductNameDetails(date) {
    return request({
        url: '/adminapi/getAllProductNameDetails',
        method: 'post',
        data: date
    })
}

export function getAllProductNameDetail(date) {
    return request({
        url: '/adminapi/getAllProductNameDetail',
        method: 'post',
        data: date
    })
}

// 确认出库
export function confirmDelivery(date) {
    return request({
        url: '/adminapi/confirmDelivery',
        method: 'post',
        data: date
    })
}

// 导出出库单
export function daoDelivery(date) {
    return request({
        url: '/adminapi/daoDelivery',
        method: 'post',
        data: date
    })
}

export function bjDeliveryDetails(date) {
    return request({
        url: '/adminapi/bjDeliveryDetails',
        method: 'post',
        data: date
    })
}

// 保存编辑
export function saveWarehousing(date) {
    return request({
        url: '/adminapi/saveWarehousing',
        method: 'post',
        data: date
    })
}

// 查看入库单
export function chaWarehousingDetails(date) {
    return request({
        url: '/adminapi/chaWarehousingDetails',
        method: 'post',
        data: date
    })
}

// 删除入库
export function delWarehousing(date) {
    return request({
        url: '/adminapi/delWarehousing',
        method: 'post',
        data: date
    })
}

// 入库单确认
export function confirmWarehousing(date) {
    return request({
        url: '/adminapi/confirmWarehousing',
        method: 'post',
        data: date
    })
}

export function bjWarehousingDetails(date) {
    return request({
        url: '/adminapi/bjWarehousingDetails',
        method: 'post',
        data: date
    })
}

// 导出入库数据
export function daoWarehousing(date) {
    return request({
        url: '/adminapi/daoWarehousing',
        method: 'post',
        data: date
    })
}

// 出库表单数据
export function DeliveryIndex(date) {
    return request({
        url: '/adminapi/DeliveryIndex',
        method: 'post',
        data: date
    })
}

// 保存新录出库单
export function saveDelivery(date) {
    return request({
        url: '/adminapi/saveDelivery',
        method: 'post',
        data: date
    })
}

// 删除出库单
export function delDelivery(date) {
    return request({
        url: '/adminapi/delDelivery',
        method: 'post',
        data: date
    })
}

// 查看出货单详情
export function chaDeliveryDetails(date) {
    return request({
        url: '/adminapi/chaDeliveryDetails',
        method: 'post',
        data: date
    })
}

// 分仓库库存列表
export function subWarehouseIndex(date) {
    return request({
        url: '/adminapi/subWarehouseIndex',
        method: 'post',
        data: date
    })
}

// 导出分仓库库存列表
export function daoSubWarehouse(date) {
    return request({
        url: '/adminapi/daoSubWarehouse',
        method: 'post',
        data: date
    })
}

export function allWarehouses(date) {
    return request({
        url: '/adminapi/allWarehouses',
        method: 'post',
        data: date
    })
}

export function getAllProductNames(date) {
    return request({
        url: '/adminapi/getAllProductNames',
        method: 'post',
        data: date
    })
}

// 取货码订单列表
export function pickupOrderIndex(date) {
    return request({
        url: '/adminapi/pickupOrderIndex',
        method: 'post',
        data: date
    })
}

//
export function saveLathe(date) {
    return request({
        url: '/adminapi/saveLathe',
        method: 'post',
        data: date
    })
}

export function saveWs(date) {
    return request({
        url: '/adminapi/saveWs',
        method: 'post',
        data: date
    })
}export function saveUserGroup(date) {
    return request({
        url: '/adminapi/saveUserGroup',
        method: 'post',
        data: date
    })
}
export function getLatheList(date) {
    return request({
        url: '/adminapi/getLatheList',
        method: 'post',
        data: date
    })
}

export function getWsList(date) {
    return request({
        url: '/adminapi/getWsList',
        method: 'post',
        data: date
    })
}
export function getUserGroupList(date) {
    return request({
        url: '/adminapi/getUserGroupList',
        method: 'post',
        data: date
    })
}

export function getVisibleUserGroupList(date) {
    return request({
        url: '/adminapi/getVisibleUserGroupList',
        method: 'post',
        data: date
    })
}

export function moveOrganization(date) {
    return request({
        url: '/adminapi/moveOrganization',
        method: 'post',
        data: date
    })
}

// 删除码订单列表
export function pickupOrderDel(date) {
    return request({
        url: '/adminapi/pickupOrderDel',
        method: 'post',
        data: date
    })
}

// 导出数据
export function daopickupOrder(date) {
    return request({
        url: '/adminapi/daopickupOrder',
        method: 'post',
        data: date
    })
}

// 订单详情
export function pickupOrderDetails(date) {
    return request({
        url: '/adminapi/pickupOrderDetails',
        method: 'post',
        data: date
    })
}

/**
 * 机器列表
 */
export function machinesIndex(signcote) {
    return request({
        url: '/adminapi/machinesIndex',
        method: 'post',
        data: signcote
    })
}

/**
 * 机器列表
 */
export function getRunSetting(signcote) {
    return request({
        url: '/adminapi/getRunSetting',
        method: 'post',
        data: signcote
    })
}

// 温控设置
export function runSetting(date) {
    return request({
        url: '/adminapi/runSetting',
        method: 'post',
        data: date
    })
}

/**
 * 查看图片
 */
export function machineImg(imgid) {
    return request({
        url: '/adminapi/machineImg',
        method: 'post',
        data: imgid
    })
}

/**
 * 操作机器
 */
export function restart(OPmace) {
    return request({
        url: '/adminapi/restart',
        method: 'post',
        data: OPmace
    })
}

/**
 * 清空货道
 */
export function delroad(aisle) {
    return request({
        url: '/adminapi/delroad',
        method: 'post',
        data: aisle
    })
}

/**
 * 获取编辑货道数据
 */
export function getdetail(compile) {
    return request({
        url: '/adminapi/getdetail',
        method: 'post',
        data: compile
    })
}
/**
 * 获取机器管道数据
 */
export function getMacPipe(compile) {
    return request({
        url: '/adminapi/getMacPipe',
        method: 'post',
        data: compile
    })
}
/**
 * 新增机器管道数据
 */
export function addMacPipe(compile) {
    return request({
        url: '/adminapi/addMacPipe',
        method: 'post',
        data: compile
    })
}
/**
 * 删除机器管道数据
 */
export function delMacPipe(compile) {
    return request({
        url: '/adminapi/delMacPipe',
        method: 'post',
        data: compile
    })
}
/**
 * 根据ID获取机器管道数据
 */
export function getMacPipeById(compile) {
    return request({
        url: '/adminapi/getMacPipeById',
        method: 'post',
        data: compile
    })
}
/**
 * 复制机器管道数据
 */
export function copyMacPipe(compile) {
    return request({
        url: '/adminapi/copyMacPipe',
        method: 'post',
        data: compile
    })
}
/**
 * sn切换
 */
export function snswap(compile) {
    return request({
        url: '/adminapi/snswap',
        method: 'post',
        data: compile
    })
}

/** 主账号：批量设置 machines.targetversion */
export function setMachinesTargetVersion(compile) {
    return request({
        url: '/adminapi/setMachinesTargetVersion',
        method: 'post',
        data: compile
    })
}

/**
 * 一键补满机器通道
 */
export function fillMacPipe(compile) {
    return request({
        url: '/adminapi/fillMacPipe',
        method: 'post',
        data: compile
    })
}
// 查看机器状态
export function open(id) {
    const params = {
        id
    }
    return request({
        url: '/adminapi/open',
        method: 'get',
        params
    })
}

// 查看今日在线时长
export function onlineDuration(id) {
    const params = {
        id
    }
    return request({
        url: '/adminapi/onlineDuration',
        method: 'get',
        params
    })
}

/**
 * 导出表格数据
 */
export function daoMachines(rows) {
    return request({
        url: '/adminapi/daoMachines',
        method: 'post',
        data: rows
    })
}

// 批量导入
export function batchAddingMachines(bodate) {
    return request({
        url: '/adminapi/batchAddingMachines',
        method: 'post',
        data: bodate
    })
}

// 保存编辑
export function jq_addsave(addrest) {
    return request({
        url: '/adminapi/jq_addsave',
        method: 'post',
        data: addrest
    })
}

// 机器型号
export function machineTypeIndex(date) {
    return request({
        url: '/adminapi/machineTypeIndex',
        method: 'post',
        data: date
    })
}

// 机器型号编辑 获取详情
export function getTypeDetail(date) {
    return request({
        url: '/adminapi/getTypeDetail',
        method: 'post',
        data: date
    })
}

// 保存编辑
export function saveMachineType(date) {
    return request({
        url: '/adminapi/saveMachineType',
        method: 'post',
        data: date
    })
}

// 删除机器型号数据
export function delMachineType(date) {
    return request({
        url: '/adminapi/delMachineType',
        method: 'post',
        data: date
    })
}

// 导出机器型号列表
export function daoMachineType(date) {
    return request({
        url: '/adminapi/daoMachineType',
        method: 'post',
        data: date
    })
}

// 货道列表
export function roadIndex(date) {
    return request({
        url: '/adminapi/roadIndex',
        method: 'post',
        data: date
    })
}

// 货道编辑 获取详情
export function getRoadDetail(date) {
    return request({
        url: '/adminapi/getRoadDetail',
        method: 'post',
        data: date
    })
}

// 删除货道数据
export function delRoadIndex(date) {
    return request({
        url: '/adminapi/delRoadIndex',
        method: 'post',
        data: date
    })
}

//货道物品数量设置为0
export function roadSet0(date) {
    return request({
        url: '/adminapi/roadSet0',
        method: 'post',
        data: date
    })
}

// 获取播放计划详情
export function getAdPlanDetail(date) {
    return request({
        url: '/adminapi/getAdPlanDetail',
        method: 'post',
        data: date
    })
}

//保存广告计划
export function saveAdPlan(date) {
    return request({
        url: '/adminapi/saveAdPlan',
        method: 'post',
        data: date
    })
}
//领料单明细
export function getReceiveDetail(date) {
    return request({
        url: '/adminapi/getReceiveDetail',
        method: 'post',
        data: date
    })
}
//保存工单
export function saveReceive(date) {
    return request({
        url: '/adminapi/saveReceive',
        method: 'post',
        data: date
    })
}
//保存广告计划机器
export function saveAdPlanMac(date) {
    return request({
        url: '/adminapi/saveAdPlanMac',
        method: 'post',
        data: date
    })
}

//保存收款商户
export function savePayee(date) {
    return request({
        url: '/adminapi/savePayee',
        method: 'post',
        data: date
    })
}

//保存收款代理
export function savePayeeO(date) {
    return request({
        url: '/adminapi/savePayeeO',
        method: 'post',
        data: date
    })
}

export function addPayCode(date) {
    return request({
        url: '/adminapi/addPayCode2',
        method: 'post',
        data: date
    })
}

export function delPayCode(date) {
    return request({
        url: '/adminapi/delPayCode',
        method: 'post',
        data: date
    })
}

//保存微信小程序
export function saveWxxcx(date) {
    return request({
        url: '/adminapi/saveWxxcx',
        method: 'post',
        data: date
    })
}

//工作流审批人员
export function workflowUser(date) {
    return request({
        url: '/adminapi/workflowUser',
        method: 'post',
        data: date
    })
}

//工作流详情
export function getWorkflowDetail(date) {
    return request({
        url: '/adminapi/getWorkflowDetail',
        method: 'post',
        data: date
    })
}

//工作流审批类型列表
export function workflowIndex(date) {
    return request({
        url: '/adminapi/workflowIndex',
        method: 'post',
        data: date
    })
}

//保存工作流审批列表
export function saveWorkflow(date) {
    return request({
        url: '/adminapi/saveWorkflow',
        method: 'post',
        data: date
    })
}

//保存优惠券种类
export function saveCoupon(date) {
    return request({
        url: '/adminapi/saveCoupon',
        method: 'post',
        data: date
    })
}

//生成优惠券
export function addCouponIssuance(date) {
    return request({
        url: '/adminapi/addCouponIssuance',
        method: 'post',
        data: date
    })
}

//保存套餐
export function saveSetMeal(date) {
    return request({
        url: '/adminapi/saveSetMeal',
        method: 'post',
        data: date
    })
}

//保存版本
export function saveVersion(date) {
    return request({
        url: '/adminapi/saveVersion',
        method: 'post',
        data: date
    })
}

//保存公众号
export function saveWx(date) {
    return request({
        url: '/adminapi/saveWx',
        method: 'post',
        data: date
    })
}

export function adpMacSelectList(date) {
    return request({
        url: '/adminapi/adpMacSelectList',
        method: 'post',
        data: date
    })
}

//保存广告计划
export function delAdPlan(date) {
    return request({
        url: '/adminapi/delAdPlan',
        method: 'post',
        data: date
    })
}

export function productMachinesIndex(date) {
    return request({
        url: '/adminapi/productMachinesIndex',
        method: 'post',
        data: date
    })
}

export function getRoadHis(date) {
    return request({
        url: '/adminapi/getRoadHis',
        method: 'post',
        data: date
    })
}

export function getRoadHisLast(date) {
    return request({
        url: '/adminapi/getRoadHisLast',
        method: 'post',
        data: date
    })
}

export function getBoxHis(date) {
    return request({
        url: '/adminapi/getBoxHis',
        method: 'post',
        data: date
    })
}
// 导出货道列表
export function daoRoad(date) {
    return request({
        url: '/adminapi/daoRoad',
        method: 'post',
        data: date
    })
}

// 复制货道
export function saveAisle(date) {
    return request({
        url: '/adminapi/saveAisle',
        method: 'post',
        data: date
    })
}

// 批量改价，数量
export function editSome(date) {
    return request({
        url: '/adminapi/editSome',
        method: 'post',
        data: date
    })
}

// 货道变动历史列表
export function getHistoryList(date) {
    return request({
        url: '/adminapi/getHistoryList',
        method: 'post',
        data: date
    })
}

// 物品列表
export function productIndex(date) {
    return request({
        url: '/adminapi/productIndex',
        method: 'post',
        data: date
    })
}
// 获取组织的机台供商品选择
export function getProductLathe(date) {
    return request({
        url: '/adminapi/getProductLathe',
        method: 'post',
        data: date
    })
}
// 物品编辑获取详情
export function getProductDetail(date) {
    return request({
        url: '/adminapi/getProductDetail',
        method: 'post',
        data: date
    })
}

// 预补货单：PC 建单、编辑和查看；手机端接口在移动项目复用同一后端契约。
export function preReplenishmentIndex(data) {
    return request({ url: '/adminapi/preReplenishmentIndex', method: 'post', data })
}

export function preReplenishmentRoads(data) {
    return request({ url: '/adminapi/preReplenishmentRoads', method: 'post', data })
}

export function createPreReplenishment(data) {
    return request({ url: '/adminapi/createPreReplenishment', method: 'post', data })
}

export function updatePreReplenishment(data) {
    return request({ url: '/adminapi/updatePreReplenishment', method: 'post', data })
}

export function cancelPreReplenishment(data) {
    return request({ url: '/adminapi/cancelPreReplenishment', method: 'post', data })
}

export function preReplenishmentDetail(data) {
    return request({ url: '/adminapi/preReplenishmentDetail', method: 'post', data })
}
// 商品页可维护的产品用刀清单和当前关联
export function getProductToolingProducts(date) {
    return request({
        url: '/adminapi/getProductToolingProducts',
        method: 'post',
        data: date
    })
}
// 物品原料详情
export function getProductMaterialDetail(date) {
    return request({
        url: '/adminapi/getProductMaterialDetail',
        method: 'post',
        data: date
    })
}
// 保存物品编辑
export function saveProduct(date) {
    return request({
        url: '/adminapi/saveProduct',
        method: 'post',
        data: date
    })
}

export function toolingProductIndex(params) {
    return request({ url: '/adminapi/toolingProductIndex', method: 'get', params })
}

export function toolingProductDetail(params) {
    return request({ url: '/adminapi/toolingProductDetail', method: 'get', params })
}

export function toolingProductTools(params) {
    return request({ url: '/adminapi/toolingProductTools', method: 'get', params })
}

export function toolingProductSave(data) {
    return request({ url: '/adminapi/toolingProductSave', method: 'post', data })
}

export function toolingProductDelete(data) {
    return request({ url: '/adminapi/toolingProductDelete', method: 'post', data })
}

export function toolingProductOrganizations() {
    return request({ url: '/adminapi/toolingProductOrganizations', method: 'get' })
}
// 保存商品指导价并同步到使用该商品的有效货道
export function syncProductRoadPrice(date) {
    return request({
        url: '/adminapi/syncProductRoadPrice',
        method: 'post',
        data: date
    })
}
// 获取所有商品
export function allProductAndCategory(date) {
    return request({
        url: '/adminapi/allProductAndCategory',
        method: 'post',
        data: date
    })
}
// 导入物品
export function saveProductDaoRu(date) {
    return request({
        url: '/adminapi/saveProductDaoRu',
        method: 'post',
        data: date
    })
}
// 货道模板删除
export function delRoadTemplateDetail(date) {
    return request({
        url: '/adminapi/delRoadTemplateDetail',
        method: 'post',
        data: date
    })
}

// 删除物品列表
export function delProduct(date) {
    return request({
        url: '/adminapi/delProduct',
        method: 'post',
        data: date
    })
}

// 下架物品列表
export function updataStatus(date) {
    return request({
        url: '/adminapi/updataStatus',
        method: 'post',
        data: date
    })
}

// 导出物品
export function daoProduct(date) {
    return request({
        url: '/adminapi/daoProduct',
        method: 'post',
        data: date
    })
}

// 物品分类列表
export function productCategoryIndex(date) {
    return request({
        url: '/adminapi/productCategoryIndex',
        method: 'post',
        data: date
    })
}
// 物品分类列表
export function productCategoryOid(date) {
    return request({
        url: '/adminapi/productCategoryOid',
        method: 'post',
        data: date
    })
}
export function allCategoryName() {
    return request({
        url: '/adminapi/allCategoryName',
        method: 'GET'
    })
}

// 编辑分类 获取详情
export function getCategoryDetail(date) {
    return request({
        url: '/adminapi/getCategoryDetail',
        method: 'post',
        data: date
    })
}

// 保存编辑
export function saveCategory(date) {
    return request({
        url: '/adminapi/saveCategory',
        method: 'post',
        data: date
    })
}

// 删除分类
export function delCategory(date) {
    return request({
        url: '/adminapi/delCategory',
        method: 'post',
        data: date
    })
}

export function uppic(date) {
    return request({
        url: '/adminapi/uppic',
        method: 'post',
        data: date
    })
}

// 品牌列表
export function brandIndex(date) {
    return request({
        url: '/adminapi/brandIndex',
        method: 'post',
        data: date
    })
}

// 获取所有品牌
export function allBrandName() {
    return request({
        url: '/adminapi/allBrandName',
        method: 'GET'
    })
}

// 编辑品牌 获取详情
export function getBrandDetail(date) {
    return request({
        url: '/adminapi/getBrandDetail',
        method: 'post',
        data: date
    })
}

// 保存编辑/新录
export function saveBrand(date) {
    return request({
        url: '/adminapi/saveBrand',
        method: 'post',
        data: date
    })
}

// 删除品牌
export function delBrand(date) {
    return request({
        url: '/adminapi/delBrand',
        method: 'post',
        data: date
    })
}

// 今日缺货清单列表
export function replenishmentIndex(date) {
    return request({
        url: '/adminapi/replenishmentIndex',
        method: 'post',
        data: date
    })
}

// 查看出库单
export function outboundOrder(date) {
    return request({
        url: '/adminapi/outboundOrder',
        method: 'post',
        data: date
    })
}

// 查看缺货清单
export function replenishmentNote(date) {
    return request({
        url: '/adminapi/replenishmentNote',
        method: 'post',
        data: date
    })
}

// 更新缺货清单
export function updateReplenishment(date) {
    return request({
        url: '/adminapi/updateReplenishment',
        method: 'post',
        data: date
    })
}

// 打印出库单汇总
export function getOutall(date) {
    return request({
        url: '/adminapi/getOutall',
        method: 'post',
        data: date
    })
}

// 补货历史
export function historyIndex(date) {
    return request({
        url: '/adminapi/historyIndex',
        method: 'post',
        data: date
    })
}

// 订单列表
export function orderIndex(date) {
    return request({
        url: '/adminapi/orderIndex',
        method: 'post',
        data: date
    })
}

// 盲盒订单列表
export function getBlinkboxOrderList(date) {
    return request({
        url: '/adminapi/getBlinkboxOrderList',
        method: 'post',
        data: date
    })
}

// 保存盲盒提现
export function saveBlinkboxOrderWithdrawal(date) {
    return request({
        url: '/adminapi/saveBlinkboxOrderWithdrawal',
        method: 'post',
        data: date
    })
}

// 盲盒提现订单列表
export function getBlinkboxOrderWithdrawalList(date) {
    return request({
        url: '/adminapi/getBlinkboxOrderWithdrawalList',
        method: 'post',
        data: date
    })
}

// 智能柜订单
export function orderEmergencyIndex(date) {
    return request({
        url: '/adminapi/orderEmergencyIndex',
        method: 'post',
        data: date
    })
}

// 智能柜订单详情
export function orderEmergencyDetail(date) {
    return request({
        url: '/adminapi/orderEmergencyDetail ',
        method: 'post',
        data: date
    })
}

// 查看订单时间日志
export function orderLog(date) {
    return request({
        url: '/adminapi/orderLog',
        method: 'post',
        data: date
    })
}

// 退款
export function getRefundDetail(date) {
    return request({
        url: '/adminapi/getRefundDetail',
        method: 'post',
        data: date
    })
}
export function getAdminUsers(date) {
    return request({
        url: '/adminapi/getAdminUsers',
        method: 'post',
        data: date
    })
}
// 新录货道模板
export function saveRoadTemplate(date) {
    return request({
        url: '/adminapi/saveRoadTemplate',
        method: 'post',
        data: date
    })
}

// 设置货道备注（rid 新客户端单货道；无 rid 兼容旧客户端批量）
export function saveRoadEpithet(date) {
    return request({
        url: '/adminapi/saveRoadEpithet',
        method: 'post',
        data: date
    })
}


// 导出用户售货机订单
export function exportOrder(date) {
    return request({
        url: '/adminapi/exportOrder',
        method: 'post',
        data: date
    })
}

// 退款列表
export function refundIndex(date) {
    return request({
        url: '/adminapi/refundIndex',
        method: 'post',
        data: date
    })
}

// 导出退款列表
export function daoRefund(date) {
    return request({
        url: '/adminapi/daoRefund',
        method: 'post',
        data: date
    })
}

// 确定退款
export function saveRefund(date) {
    return request({
        url: '/adminapi/saveRefund',
        method: 'post',
        data: date
    })
}

// 终止订单
export function orderEnd(date) {
    return request({
        url: '/adminapi/orderEnd',
        method: 'post',
        data: date
    })
}
// 终止工单
export function orderReceiveEnd(date) {
    return request({
        url: '/adminapi/orderReceiveEnd',
        method: 'post',
        data: date
    })
}
// //取消/确认收货/发货订单
export function operationOrderFormMaterial(date) {
    return request({
        url: '/adminapi/operationOrderFormMaterial',
        method: 'post',
        data: date
    })
}
// 终止格子柜订单
export function orderBoxEnd(date) {
    return request({
        url: '/adminapi/orderBoxEnd',
        method: 'post',
        data: date
    })
}

// 每台机器销售金额
export function machineSalesAmountIndex(date) {
    return request({
        url: '/adminapi/machineSalesAmountIndex',
        method: 'post',
        data: date
    })
}

// 查看每台销售金额信息
export function getSalesDetails(date) {
    return request({
        url: '/adminapi/getSalesDetails',
        method: 'post',
        data: date
    })
}

// 导出每台机器销售金额
export function daoMachineSalesAmountIndex(date) {
    return request({
        url: '/adminapi/daoMachineSalesAmountIndex',
        method: 'post',
        data: date
    })
}

// 签约列表
export function signupIndex(date) {
    return request({
        url: '/adminapi/signupIndex',
        method: 'post',
        data: date
    })
}

// 获取签约详情
export function getSignupDetail(date) {
    return request({
        url: '/adminapi/getSignupDetail',
        method: 'post',
        data: date
    })
}

// 导出数据
export function daoSignup(date) {
    return request({
        url: '/adminapi/daoSignup',
        method: 'post',
        data: date
    })
}

// 合同结算列表
export function contractIndex(date) {
    return request({
        url: '/adminapi/contractIndex',
        method: 'post',
        data: date
    })
}

// 查看每日每台数据
export function getDataPerMachine(date) {
    return request({
        url: '/adminapi/getDataPerMachine',
        method: 'post',
        data: date
    })
}

// 获取每日机器信息
export function getDailyData(date) {
    return request({
        url: '/adminapi/getDailyData',
        method: 'post',
        data: date
    })
}

//  导出合同结算列表信息数据到excel
export function daoContract(date) {
    return request({
        url: '/adminapi/daoContract',
        method: 'post',
        data: date
    })
}

// 仓库列表
export function arehouseIndex(date) {
    return request({
        url: '/adminapi/storageIndex',
        method: 'post',
        data: date
    })
}

// 编辑仓库
export function getArehouseDetail(date) {
    return request({
        url: '/adminapi/ck_details',
        method: 'post',
        data: date
    })
}

// 保存仓库编辑
export function saveArehouse(date) {
    return request({
        url: '/adminapi/saveArehouse',
        method: 'post',
        data: date
    })
}

// 删除仓库
export function delArehouse(date) {
    return request({
        url: '/adminapi/delStorage',
        method: 'post',
        data: date
    })
}

// 库存列表
export function stockIndex(date) {
    return request({
        url: '/adminapi/stockIndex',
        method: 'post',
        data: date
    })
}

// 编辑库存
export function getStockDetail(date) {
    return request({
        url: '/adminapi/getStockDetail',
        method: 'post',
        data: date
    })
}

// 保存编辑
export function saveStock(date) {
    return request({
        url: '/adminapi/saveStock',
        method: 'post',
        data: date
    })
}

// 删除库存
export function delStock(date) {
    return request({
        url: '/adminapi/delStock',
        method: 'post',
        data: date
    })
}

// 数量变动列表
export function numChangIndex(date) {
    return request({
        url: '/adminapi/numChangIndex',
        method: 'post',
        data: date
    })
}

// 入库详情
export function getOutStockDetail(date) {
    return request({
        url: '/adminapi/getOutStockDetail',
        method: 'post',
        data: date
    })
}

// 保存入库详情
export function saveOutStock(date) {
    return request({
        url: '/adminapi/saveOutStock',
        method: 'post',
        data: date
    })
}

// 搜索扫码登记
export function getBarDetail(date) {
    return request({
        url: '/adminapi/getBarDetail',
        method: 'post',
        data: date
    })
}

// 出库登记列表
export function outStockIndex(date) {
    return request({
        url: '/adminapi/outStockIndex',
        method: 'post',
        data: date
    })
}

// 广告列表
export function adIndex(date) {
    return request({
        url: '/adminapi/adIndex',
        method: 'post',
        data: date
    })
}

// 编辑广告获取详情
export function getAdDetail(date) {
    return request({
        url: '/adminapi/getAdDetail',
        method: 'post',
        data: date
    })
}

// 获取视频上传的uptoken
export function uptoken(date) {
    return request({
        url: '/adminapi/uptoken',
        method: 'post',
        data: date
    })
}
// 上传文件
export function uploadFiles(date) {
    return request({
        url: '/adminapi/uploadFiles',
        method: 'post',
        data: date
    })
}
// 修改头像
export function saveHearImg(date) {
    return request({
        url: '/adminapi/saveHearImg',
        method: 'post',
        data: date
    })
}

// 保存新录广告
export function saveAd(date) {
    return request({
        url: '/adminapi/saveAd',
        method: 'post',
        data: date
    })
}

// 删除广告
export function delAd(date) {
    return request({
        url: '/adminapi/delAd',
        method: 'post',
        data: date
    })
}

// 推送列表
export function machinesjqcode(date) {
    return request({
        url: '/adminapi/machinesjqcode',
        method: 'post',
        data: date
    })
}

// 保存广告推送
export function pushAd(date) {
    return request({
        url: '/adminapi/pushAd',
        method: 'post',
        data: date
    })
}

// 广告投放
export function adpMacIndex(date) {
    return request({
        url: '/adminapi/adpMacIndex',
        method: 'post',
        data: date
    })
}

// 广告投放
export function getAdPlanList(date) {
    return request({
        url: '/adminapi/getAdPlanList',
        method: 'post',
        data: date
    })
}

// 统计补货情况
export function replenishmentTotal(date) {
    return request({
        url: '/adminapi/replenishmentTotal',
        method: 'post',
        data: date
    })
}

// 收款商户列表
export function versionIndex(date) {
    return request({
        url: '/adminapi/versionIndex',
        method: 'post',
        data: date
    })
}

// 收款商户列表
export function payeeIndex(date) {
    return request({
        url: '/adminapi/payeeIndex',
        method: 'post',
        data: date
    })
}

// 微信小程序列表
export function wxxcxIndex(date) {
    return request({
        url: '/adminapi/wxxcxIndex',
        method: 'post',
        data: date
    })
}

// 优惠券种类列表
export function couponIndex(date) {
    return request({
        url: '/adminapi/couponIndex',
        method: 'post',
        data: date
    })
}

// 优惠券列表
export function couponIssuanceIndex(date) {
    return request({
        url: '/adminapi/couponIssuanceIndex',
        method: 'post',
        data: date
    })
}

// 套餐列表
export function setMealIndex(date) {
    return request({
        url: '/adminapi/setMealIndex',
        method: 'post',
        data: date
    })
}


// 收款代理列表
export function payeeOIndex(date) {
    return request({
        url: '/adminapi/payeeOIndex',
        method: 'post',
        data: date
    })
}

// 取货码列表
export function payCodeIndex(date) {
    return request({
        url: '/adminapi/payCodeIndex',
        method: 'post',
        data: date
    })
}

export function getPayCodeProductList(date) {
    return request({
        url: '/adminapi/getPayCodeProductList',
        method: 'post',
        data: date
    })
}

// 微信公众号列表
export function wxIndex(date) {
    return request({
        url: '/adminapi/wxIndex',
        method: 'post',
        data: date
    })
}

// 广告列表
export function machineAdvertisementIndex(date) {
    return request({
        url: '/adminapi/machineAdvertisementIndex',
        method: 'post',
        data: date
    })
}

// 查看广告投放
export function chaMachineAdvertisement(date) {
    return request({
        url: '/adminapi/chaMachineAdvertisement',
        method: 'post',
        data: date
    })
}

// 保存编辑广告投放
export function saveMachineAdvertisement(date) {
    return request({
        url: '/adminapi/saveMachineAdvertisement',
        method: 'post',
        data: date
    })
}

// 批量删除
export function delMachineAdvertisement(date) {
    return request({
        url: '/adminapi/delMachineAdvertisement',
        method: 'post',
        data: date
    })
}

// 批量上下架
export function machineAdvertisingStatus(date) {
    return request({
        url: '/adminapi/machineAdvertisingStatus',
        method: 'post',
        data: date
    })
}

// 改变上下架状态
export function updateStatus(date) {
    return request({
        url: '/adminapi/updateStatus',
        method: 'post',
        data: date
    })
}

// 组织管理树形图
export function organizationIndex(date) {
    return request({
        url: '/adminapi/organizationIndex',
        method: 'post',
        data: date
    })
}

// 机构用户表格
export function organizationNameIndex(date) {
    return request({
        url: '/adminapi/organizationNameIndex',
        method: 'post',
        data: date
    })
}

// 获取一个超级总机构的所有物品
export function getAllProductIndex(date) {
    return request({
        url: '/adminapi/getAllProductIndex',
        method: 'post',
        data: date
    })
}
// 获取一个超级总机构的所有物品
export function getProductBymoid(date) {
    return request({
        url: '/adminapi/getProductBymoid',
        method: 'post',
        data: date
    })
}
// 获取一个超级总机构的所有物品新
export function getAllProductIndexNew(date) {
    return request({
        url: '/adminapi/getAllProductIndexNew',
        method: 'post',
        data: date
    })
}
// 工单点击商品日志
export function getOrderLog(date) {
    return request({
        url: '/adminapi/getOrderLog',
        method: 'post',
        data: date
    })
}
//导入领料单
export function daoruOrderReceive(date) {
    return request({
        url: '/adminapi/daoruOrderReceive',
        method: 'post',
        data: date
    })
}
// 获取一个分类的物品
export function getAllProductCid(date) {
    return request({
        url: '/adminapi/getAllProductCid',
        method: 'post',
        data: date
    })
}

// 新录领用点
export function addOrganization(date) {
    return request({
        url: '/adminapi/addOrganization',
        method: 'post',
        data: date
    })
}

// 获取机构详情
export function getOrganizationDetail(date) {
    return request({
        url: '/adminapi/getOrganizationDetail',
        method: 'post',
        data: date
    })
}

// 货道模板~查看和编辑的接口
export function getRoadTemplateDetail(date) {
    return request({
        url: '/adminapi/getRoadTemplateDetail',
        method: 'post',
        data: date
    })
}

// 保存编辑机构
export function saveOrganization(date) {
    return request({
        url: '/adminapi/saveOrganization',
        method: 'post',
        data: date
    })
}

// 货道模板列表
export function roadTemplateIndex(date) {
    return request({
        url: '/adminapi/roadTemplateIndex',
        method: 'post',
        data: date
    })
}

// 删除机构
export function delOrganization(date) {
    return request({
        url: '/adminapi/delOrganization',
        method: 'post',
        data: date
    })
}

// 新录机构用户
export function addOrganizationUser(date) {
    return request({
        url: '/adminapi/addOrganizationUser',
        method: 'post',
        data: date
    })
}

// 导入mes
export function checkMesOrganizationUser(date) {
    return request({
        url: '/adminapi/checkMesOrganizationUser',
        method: 'post',
        data: date
    })
}

export function checkMesProduct(date) {
    return request({
        url: '/adminapi/checkMesProduct',
        method: 'post',
        data: date
    })
}

export function checkProduct(date) {
    return request({
        url: '/adminapi/checkProduct',
        method: 'post',
        data: date
    })
}
// 新录机构用户
export function getAddAdminAuth(date) {
    return request({
        url: '/adminapi/getAddAdminAuth',
        method: 'post',
        data: date
    })
}

// 获取当前登录者的权限
export function getAdminRoleList(date) {
    return request({
        url: '/adminapi/getAdminRoleList',
        method: 'post',
        data: date
    })
}

// 编辑机构用户获取详情
export function getOrganizationUserDetail(date) {
    return request({
        url: '/adminapi/getOrganizationUserDetail',
        method: 'post',
        data: date
    })
}

// 保存编辑
export function saveOrganizationUser(date) {
    return request({
        url: '/adminapi/saveOrganizationUser',
        method: 'post',
        data: date
    })
}

// 删除机构用户
export function delOrganizationUser(date) {
    return request({
        url: '/adminapi/delOrganizationUser',
        method: 'post',
        data: date
    })
}
// 录入是由
export function inputbyfirm(date) {
    return request({
        url: '/adminapi/inputbyfirm',
        method: 'post',
        data: date
    })
}
// 录入是由
export function inputbyupdatedel(date) {
    return request({
        url: '/adminapi/inputbyupdatedel',
        method: 'post',
        data: date
    })
}
// 录入是由
export function getinputby(date) {
    return request({
        url: '/adminapi/getinputby',
        method: 'post',
        data: date
    })
}
export function getAdminByOrder(date) {
    return request({
        url: '/adminapi/getAdminByOrder',
        method: 'post',
        data: date
    })
}
export function zhipaiOrder(date) {
    return request({
        url: '/adminapi/zhipaiOrder',
        method: 'post',
        data: date
    })
}
// 物品机库列表
export function commodityBaseIndex(date) {
    return request({
        url: '/adminapi/commodityBaseIndex',
        method: 'post',
        data: date
    })
}

// 新录物品列表
export function getCommodityBaseDetail(date) {
    return request({
        url: '/adminapi/getCommodityBaseDetail',
        method: 'post',
        data: date
    })
}

// 保存新录
export function addCommodityBase(date) {
    return request({
        url: '/adminapi/addCommodityBase',
        method: 'post',
        data: date
    })
}

// 修改机器状态
export function updateMachinesStatus(date) {
    return request({
        url: '/adminapi/updateMachinesStatus',
        method: 'post',
        data: date
    })
}

// 远程锁机设置
export function setLockStatus(date) {
    return request({
        url: '/adminapi/setLockStatus',
        method: 'post',
        data: date
    })
}

// 远程锁机状态查询
export function getLockStatus(date) {
    return request({
        url: '/adminapi/getLockStatus',
        method: 'post',
        data: date
    })
}

// 给机器授权组织
export function machineLicensingOrganization(date) {
    return request({
        url: '/adminapi/machineLicensingOrganization',
        method: 'post',
        data: date
    })
}

// 授权人员
export function getMachineLicensingUser(date) {
    return request({
        url: '/adminapi/getMachineLicensingUser',
        method: 'post',
        data: date
    })
}

// 确定授权人员
export function machineLicensingUser(date) {
    return request({
        url: '/adminapi/machineLicensingUser',
        method: 'post',
        data: date
    })
}

// 复制货道物品
export function getRoadMachines(date) {
    return request({
        url: '/adminapi/getRoadMachines',
        method: 'post',
        data: date
    })
}

// 保存复制货道
export function copyWay(date) {
    return request({
        url: '/adminapi/copyWay',
        method: 'post',
        data: date
    })
}

// 机器详情页
export function machinesDetail(date) {
    return request({
        url: '/adminapi/machinesDetail',
        method: 'post',
        data: date
    })
}

// 修改机器详情
export function saveMachinesDetail(date) {
    return request({
        url: '/adminapi/saveMachinesDetail',
        method: 'post',
        data: date
    })
}

// 获取赠送公众号列表
export function getSubscribeWxGzhList(date) {
    return request({
        url: '/adminapi/getSubscribeWxGzhList',
        method: 'post',
        data: date
    })
}

// 修改赠送公众号
export function saveSubscribeWxGzh(date) {
    return request({
        url: '/adminapi/saveSubscribeWxGzh',
        method: 'post',
        data: date
    })
}
export function previewProductDeletion(date) {
    return request({
        url: '/adminapi/previewProductDeletion',
        method: 'post',
        data: date
    })
}
export function commitProductDeletion(date) {
    return request({
        url: '/adminapi/commitProductDeletion',
        method: 'post',
        data: date
    })
}

export function correctGrantOrder(date) {
    return request({
        url: '/adminapi/correctGrantOrder',
        method: 'post',
        data: date
    })
}

export function resolveOutorderNoFeedback(date) {
    return request({
        url: '/adminapi/resolveOutorderNoFeedback',
        method: 'post',
        data: date
    })
}

// 获取机器的公众号二维码领香配置
export function getIncenseQrConfig(date) {
    return request({
        url: '/adminapi/getIncenseQrConfig',
        method: 'post',
        data: date
    })
}

// 保存机器的公众号二维码领香配置
export function saveIncenseQrConfig(date) {
    return request({
        url: '/adminapi/saveIncenseQrConfig',
        method: 'post',
        data: date
    })
}

export function savePortionUsers(date) {
    return request({
        url: '/adminapi/savePortionUsers',
        method: 'post',
        data: date
    })
}
// 重启机器
export function restartApp(date) {
    return request({
        url: '/adminapi/restartApp',
        method: 'post',
        data: date
    })
}

// 开门
export function openDor(date) {
    return request({
        url: '/adminapi/openDor',
        method: 'post',
        data: date
    })
}

// 重启机器
export function getLog(date) {
    return request({
        url: '/adminapi/getLog',
        method: 'post',
        data: date
    })
}

export function machineLogRequest(date) {
    return request({
        url: '/adminapi/machineLogRequest',
        method: 'post',
        data: date
    })
}

export function machineLogList(date) {
    return request({
        url: '/adminapi/machineLogList',
        method: 'post',
        data: date
    })
}

export function machineLogDownload(date) {
    return request({
        url: '/adminapi/machineLogDownload',
        method: 'post',
        data: date
    })
}

export function saveMachineFactoryRemark(data) {
    return request({
        url: '/adminapi/saveMachineFactoryRemark',
        method: 'post',
        data
    })
}

export function machineLogConfig(params) {
    return request({ url: '/adminapi/machineLogConfig', method: 'get', params, machineLogConfig: true })
}
export function saveMachineLogConfig(data) {
    return request({ url: '/adminapi/saveMachineLogConfig', method: 'post', data, machineLogConfig: true })
}
export function redispatchMachineLogConfig(data) {
    return request({ url: '/adminapi/redispatchMachineLogConfig', method: 'post', data, machineLogConfig: true })
}
export function machineLogConfigHistory(params) {
    return request({ url: '/adminapi/machineLogConfigHistory', method: 'get', params, machineLogConfig: true })
}

export function machineRestartList(date) {
    return request({
        url: '/adminapi/machineRestartList',
        method: 'post',
        data: date
    })
}
export function clearMac(date) {
    return request({
        url: '/adminapi/clearMac',
        method: 'post',
        data: date
    })
}

// 修改物品
export function machinesRoadIndex(date) {
    return request({
        url: '/adminapi/machinesRoadIndex',
        method: 'post',
        data: date
    })
}

// 获取格子列表
export function getBoxList(date) {
    return request({
        url: '/adminapi/getBoxList',
        method: 'post',
        data: date
    })
}

// 获取待审核回收格列表
export function getRetrunBoxList(date) {
    return request({
        url: '/adminapi/getRetrunBoxList',
        method: 'post',
        data: date
    })
}

// 获取待审核回收明细
export function getRetrunBoxDetail(date) {
    return request({
        url: '/adminapi/getRetrunBoxDetail',
        method: 'post',
        data: date
    })
}

// 保存回收审核
export function saveReturnExamine(date) {
    return request({
        url: '/adminapi/saveReturnExamine',
        method: 'post',
        data: date
    })
}

// 获取格子订单
export function orderBoxIndex(date) {
    return request({
        url: '/adminapi/orderBoxIndex',
        method: 'post',
        data: date
    })
}

// 获取重力柜称重会话
export function boxWeightSessionIndex(date) {
    return request({
        url: '/adminapi/boxWeightSessionIndex',
        method: 'post',
        data: date
    })
}

// 复核重力柜异常会话
export function boxWeightSessionReview(date) {
    return request({
        url: '/adminapi/boxWeightSessionReview',
        method: 'post',
        data: date
    })
}
// 领料单
export function orderReceiveIndex(date) {
    return request({
        url: '/adminapi/orderReceiveIndex',
        method: 'post',
        data: date
    })
}
// 工单领用记录
export function orderReceiveGoodsIndex(date) {
    return request({
        url: '/adminapi/orderReceiveGoodsIndex',
        method: 'post',
        data: date,
        timeout: 60000
    })
}
// 取机器用户
export function getusers(date) {
    return request({
        url: '/adminapi/getusers',
        method: 'post',
        data: date
    })
}
// 获取格子订单
export function daoGrantUserStatements(date) {
    return request({
        url: '/adminapi/daoGrantUserStatements',
        method: 'post',
        data: date
    })
}

// 个人领料统计
export function grantUserStatementsIndex(date) {
    return request({
        url: '/adminapi/grantUserStatementsIndex',
        method: 'post',
        data: date
    })
}
// 商品销售
export function salesStatistics(date) {
    return request({
        url: '/adminapi/salesStatistics',
        method: 'post',
        data: date
    })
}
// 商品销售（按机器统计）
export function salesStatisticsbymac(date) {
    return request({
        url: '/adminapi/salesStatisticsbymac',
        method: 'post',
        data: date
    })
}
export function borrowStatementsIndex(date) {
    return request({
        url: '/adminapi/borrowStatementsIndex',
        method: 'post',
        data: date
    })
}

//机台用料统计
export function mac_materialsIndex(date) {
    return request({
        url: '/adminapi/mac_materialsIndex',
        method: 'post',
        data: date
    })
}

//机台超量告警
export function productalertlog(date) {
    return request({
        url: '/adminapi/productalertlog',
        method: 'post',
        data: date
    })
}
//用料超量阅读
export function productAlertLogread(date) {
    return request({
        url: '/adminapi/productAlertLogread',
        method: 'post',
        data: date
    })
}
//用料超量接口
export function productAlertLogInsert(date) {
    return request({
        url: '/adminapi/productAlertLogInsert',
        method: 'post',
        data: date
    })
}
// 机台用刀统计
export function machine_statistics(date) {
    return request({
        url: '/adminapi/machine_statistics',
        method: 'post',
        data: date
    })
}


export function oneUserSalesRanking(date) {
    return request({
        url: '/adminapi/oneUserSalesRanking',
        method: 'post',
        data: date
    })
}

export function oneUserBorrowRanking(date) {
    return request({
        url: '/adminapi/oneUserBorrowRanking',
        method: 'post',
        data: date
    })
}

export function productBorrowRanking(date) {
    return request({
        url: '/adminapi/productBorrowRanking',
        method: 'post',
        data: date
    })
}

export function grantUserStatementsTotalIndex(date) {
    return request({
        url: '/adminapi/grantUserStatementsTotalIndex',
        method: 'post',
        data: date
    })
}
// 机器用刀统计（含期初/期末库存）
export function grantMacStatementsIndex(date) {
    return request({
        url: '/adminapi/grantMacStatementsIndex',
        method: 'post',
        data: date
    })
}

// 机器用刀统计（精简：无「期初/期末」）
export function grantMacStatementsIndexLite(date) {
    return request({
        url: '/adminapi/grantMacStatementsIndexLite',
        method: 'post',
        data: date
    })
}

// 设置货道使用人
export function setRoadUsers(date) {
    return request({
        url: '/adminapi/setRoadUsers',
        method: 'post',
        data: date
    })
}
// 保存格子
export function saveBox(date) {
    return request({
        url: '/adminapi/saveBox',
        method: 'post',
        data: date
    })
}
// 开格子
export function toOpenBox(date) {
    return request({
        url: '/adminapi/toOpenBox',
        method: 'post',
        data: date
    })
}
// 获取货道详情
export function getUpdateRoadDetail(date) {
    return request({
        url: '/adminapi/getUpdateRoadDetail',
        method: 'post',
        data: date
    })
}

// 合并货道
export function mergingFreightLanes(date) {
    return request({
        url: '/adminapi/mergingFreightLanes',
        method: 'post',
        data: date
    })
}

// 确定合并
export function querenMergingFreightLanes(date) {
    return request({
        url: '/adminapi/querenMergingFreightLanes',
        method: 'post',
        data: date
    })
}

// 保存修改货道物品
export function saveRoad(date) {
    return request({
        url: '/adminapi/saveRoad',
        method: 'post',
        data: date
    })
}

// 批量修改货道物品
export function saveAllRoad(date) {
    return request({
        url: '/adminapi/saveAllRoad',
        method: 'post',
        data: date
    })
}

export function getAllUpdateRoadDetail(date) {
    return request({
        url: '/adminapi/getAllUpdateRoadDetail',
        method: 'post',
        data: date
    })
}

// 修改价格列表
export function getMachinesProductIndex(date) {
    return request({
        url: '/adminapi/getMachinesProductIndex',
        method: 'post',
        data: date
    })
}

// 修改价格信息
export function getMachinesProductDetail(date) {
    return request({
        url: '/adminapi/getMachinesProductDetail',
        method: 'post',
        data: date
    })
}

// 保存修改价格
export function saveMachinesProductDetail(date) {
    return request({
        url: '/adminapi/saveMachinesProductDetail',
        method: 'post',
        data: date
    })
}

// 单个修改货道开关
export function updateRoadStatus(date) {
    return request({
        url: '/adminapi/updateRoadStatus',
        method: 'post',
        data: date
    })
}

// 关闭/开启整层
export function updateAllRoadStatus(date) {
    return request({
        url: '/adminapi/updateAllRoadStatus',
        method: 'post',
        data: date
    })
}

// 缺货清单
export function chaReplenishmentNote(date) {
    return request({
        url: '/adminapi/chaReplenishmentNote',
        method: 'post',
        data: date
    })
}
// 缺货清单
export function chaReplenishmentNoteNew(date) {
    return request({
        url: '/adminapi/chaReplenishmentNoteNew',
        method: 'post',
        data: date
    })
}
// 更改货道信息
export function getMacsRoadDetail(date) {
    return request({
        url: '/adminapi/getMacsRoadDetail',
        method: 'post',
        data: date
    })
}

// 修改货道保存编辑
export function saveMachinesBox(date) {
    return request({
        url: '/adminapi/saveMachinesBox',
        method: 'post',
        data: date
    })
}

// 修改货道保存编辑
export function saveMachinesRoad(date) {
    return request({
        url: '/adminapi/saveMachinesRoad',
        method: 'post',
        data: date
    })
}

/** 仅保存无升降柜号，不写货道 */
export function saveMachinesNopush(date) {
    return request({
        url: '/adminapi/saveMachinesNopush',
        method: 'post',
        data: date
    })
}

// 问题列表
export function problemIndex(date) {
    return request({
        url: '/adminapi/problemIndex',
        method: 'post',
        data: date
    })
}

// 补满
export function fullAllRoad(date) {
    return request({
        url: '/adminapi/fullAllRoad',
        method: 'post',
        data: date
    })
}

// 新录问题
export function saveProblem(date) {
    return request({
        url: '/adminapi/saveProblem',
        method: 'post',
        data: date
    })
}

// 点击编辑 获取详情
export function getProblemDetail(date) {
    return request({
        url: '/adminapi/getProblemDetail',
        method: 'post',
        data: date
    })
}

export function delProblem(date) {
    return request({
        url: '/adminapi/delProblem',
        method: 'post',
        data: date
    })
}

// 新录故障
export function saveTroubleShooting(date) {
    return request({
        url: '/adminapi/saveTroubleShooting',
        method: 'post',
        data: date
    })
}

export function troubleShootingIndex(date) {
    return request({
        url: '/adminapi/troubleShootingIndex',
        method: 'post',
        data: date
    })
}
export function material(date) {
    return request({
        url: '/adminapi/material',
        method: 'post',
        data: date
    })
}
export function materialCategory(date) {
    return request({
        url: '/adminapi/materialCategory',
        method: 'post',
        data: date
    })
}
export function getCategoryLists(date) {
    return request({
        url: '/adminapi/getCategoryLists',
        method: 'post',
        data: date
    })
}
// 订货订单列表
export function orderFormMaterialList(date) {
    return request({
        url: '/adminapi/orderFormMaterialList',
        method: 'post',
        data: date
    })
}
// 小程序会员列表
export function getXcxUserList(date) {
    return request({
        url: '/adminapi/getXcxUserList',
        method: 'post',
        data: date
    })
}
// 订货订单详情
export function getOrderFormMaterialDetail(date) {
    return request({
        url: '/adminapi/getOrderFormMaterialDetail',
        method: 'post',
        data: date
    })
}
export function getTroubleShootingDetail(date) {
    return request({
        url: '/adminapi/getTroubleShootingDetail',
        method: 'post',
        data: date
    })
}
// 分账接收方列表
export function separateAccountList(date) {
    return request({
        url: '/adminapi/separateAccountList',
        method: 'post',
        data: date
    })
}
// 保存编辑分账接收方
export function saveSeparateAccount(date) {
    return request({
        url: '/adminapi/saveSeparateAccount',
        method: 'post',
        data: date
    })
}
// 大屏幕
export function getDaPingList(date) {
    return request({
        url: '/adminapi/getDaPingList',
        method: 'post',
        data: date
    })
}
// 根据ID删除分账接收方数据
export function separateAccountDel(date) {
    return request({
        url: '/adminapi/separateAccountDel',
        method: 'post',
        data: date
    })
}
// 根据id查分账接收方数据
export function getSeparateAccountDetail(date) {
    return request({
        url: '/adminapi/getSeparateAccountDetail',
        method: 'post',
        data: date
    })
}
// 获取商品RFID列表
export function productRfidList(date) {
    return request({
        url: '/adminapi/productRfidList',
        method: 'post',
        data: date
    })
}
// 保存RFID
export function saveProductRfid(date) {
    return request({
        url: '/adminapi/saveProductRfid',
        method: 'post',
        data: date
    })
}
// 保存根据ID获取商品RFID明细
export function getProductRfidDetail(date) {
    return request({
        url: '/adminapi/getProductRfidDetail',
        method: 'post',
        data: date
    })
}
// 根据ID删除商品RFID数据
export function productRfidDel(date) {
    return request({
        url: '/adminapi/productRfidDel',
        method: 'post',
        data: date
    })
}
// 获取全部分账接收方列表
export function rfidCabinetConfigList(date) {
    return request({
        url: '/adminapi/rfidCabinetConfigList',
        method: 'post',
        data: date
    })
}
export function rfidCabinetConfigDetail(date) {
    return request({
        url: '/adminapi/rfidCabinetConfigDetail',
        method: 'post',
        data: date
    })
}
export function rfidCabinetConfigSave(date) {
    return request({
        url: '/adminapi/rfidCabinetConfigSave',
        method: 'post',
        data: date
    })
}
export function rfidCabinetRegionList(date) {
    return request({
        url: '/adminapi/rfidCabinetRegionList',
        method: 'post',
        data: date
    })
}
export function rfidCabinetRegionSave(date) {
    return request({
        url: '/adminapi/rfidCabinetRegionSave',
        method: 'post',
        data: date
    })
}
export function rfidCabinetRegionDel(date) {
    return request({
        url: '/adminapi/rfidCabinetRegionDel',
        method: 'post',
        data: date
    })
}
export function rfidCabinetSessionList(date) {
    return request({
        url: '/adminapi/rfidCabinetSessionList',
        method: 'post',
        data: date
    })
}
export function rfidCabinetSessionDetail(date) {
    return request({
        url: '/adminapi/rfidCabinetSessionDetail',
        method: 'post',
        data: date
    })
}
export function rfidCabinetSessionReview(date) {
    return request({
        url: '/adminapi/rfidCabinetSessionReview',
        method: 'post',
        data: date
    })
}
export function separateAccountLists(date) {
    return request({
        url: '/adminapi/separateAccountLists',
        method: 'post',
        data: date
    })
}
// 分账配置列表
export function separateSettingList(date) {
    return request({
        url: '/adminapi/separateSettingList',
        method: 'post',
        data: date
    })
}
// 保存编辑分账配置
export function saveSeparateSetting(date) {
    return request({
        url: '/adminapi/saveSeparateSetting',
        method: 'post',
        data: date
    })
}
// 根据ID删除分账配置数据
export function separateSettingDel(date) {
    return request({
        url: '/adminapi/separateSettingDel',
        method: 'post',
        data: date
    })
}
// 根据ID更改分账配置启用禁用
export function changeseparateSettingState(date) {
    return request({
        url: '/adminapi/changeseparateSettingState',
        method: 'post',
        data: date
    })
}
// 根据id查分账配置数据
export function getSeparateSettingDetail(date) {
    return request({
        url: '/adminapi/getSeparateSettingDetail',
        method: 'post',
        data: date
    })
}
// 分账验证列表
export function separateVerifyList(date) {
    return request({
        url: '/adminapi/separateVerifyList',
        method: 'post',
        data: date
    })
}
// 分账记录列表
export function separateDetailsList(date) {
    return request({
        url: '/adminapi/separateDetailsList',
        method: 'post',
        data: date
    })
}
// 根据id查分账记录数据
export function getSeparateDetailsDetail(date) {
    return request({
        url: '/adminapi/getSeparateDetailsDetail',
        method: 'post',
        data: date
    })
}
// 新录原料
export function saveMaterial(date) {
    return request({
        url: '/adminapi/saveMaterial',
        method: 'post',
        data: date
    })
}
// 根据id查原料数据
export function getMaterialDetail(date) {
    return request({
        url: '/adminapi/getMaterialDetail',
        method: 'post',
        data: date
    })
}
// 根据条件查原料数据
export function getMaterialLists(date) {
    return request({
        url: '/adminapi/getMaterialLists',
        method: 'post',
        data: date
    })
}
// 根据id删除原料数据
export function materialDel(date) {
    return request({
        url: '/adminapi/materialDel',
        method: 'post',
        data: date
    })
}
// 根据id更改原料上下架
export function changeMaterialState(date) {
    return request({
        url: '/adminapi/changeMaterialState',
        method: 'post',
        data: date
    })
}
// 新录原料分类
export function saveMaterialCategory(date) {
    return request({
        url: '/adminapi/saveMaterialCategory',
        method: 'post',
        data: date
    })
}
// 根据id查原料分类数据
export function getMaterialCategoryDetail(date) {
    return request({
        url: '/adminapi/getMaterialCategoryDetail',
        method: 'post',
        data: date
    })
}
// 根据id删除原料分类数据
export function materialCategoryDel(date) {
    return request({
        url: '/adminapi/materialCategoryDel',
        method: 'post',
        data: date
    })
}
export function saveMaterialTaste(date) {
    return request({
        url: '/adminapi/saveMaterialTaste',
        method: 'post',
        data: date
    })
}
//充值
export function recharge(date) {
    return request({
        url: '/adminapi/recharge',
        method: 'post',
        data: date
    })
}
// 查看故障详情
export function checkFault(date) {
    return request({
        url: '/adminapi/checkFault',
        method: 'post',
        data: date
    })
}

// 保存处理
export function handleTrouble(date) {
    return request({
        url: '/adminapi/handleTrouble',
        method: 'post',
        data: date
    })
}

// 导出订单
export function daoOrder(date) {
    return request({
        url: '/adminapi/daoOrder',
        method: 'post',
        data: date
    })
}

// 导出智能柜订单列表
export function daoOrderEmergency(date) {
    return request({
        url: '/adminapi/daoOrderEmergency',
        method: 'post',
        data: date
    })
}

// 经营报表
export function operatingStatementsIndex(date) {
    return request({
        url: '/adminapi/operatingStatementsIndex',
        method: 'post',
        data: date
    })
}

export function machinesDayTurnover(date) {
    return request({
        url: '/adminapi/machinesDayTurnover',
        method: 'post',
        data: date
    })
}

// 按月导出
export function machinesMonth(date) {
    return request({
        url: '/adminapi/machinesMonth',
        method: 'post',
        data: date
    })
}

// 按天导出
export function MachinesDay(date) {
    return request({
        url: '/adminapi/MachinesDay',
        method: 'post',
        data: date
    })
}

// 补货记录
export function RecordDuring(date) {
    return request({
        url: '/adminapi/RecordDuring',
        method: 'post',
        data: date
    })
}

// 补货详情
export function RecordDuringDetails(date) {
    return request({
        url: '/adminapi/RecordDuringDetails',
        method: 'post',
        data: date
    })
}

// 用户列表
export function drugUsersIndex(date) {
    return request({
        url: '/adminapi/drugUsersIndex',
        method: 'post',
        data: date
    })
}

// 导出用户列表
export function daoDrugUsers(date) {
    return request({
        url: '/adminapi/daoDrugUsers',
        method: 'post',
        data: date
    })
}
// 存储列表
export function storageList(date) {
    return request({
        url: '/adminapi/storageList',
        method: 'post',
        data: date
    })
}
//切换存储状态
export function storageChange(date) {
    return request({
        url: '/adminapi/storageChange',
        method: 'post',
        data: date
    })
}
//获取存储设置信息
export function storageSetup(date) {
    return request({
        url: '/adminapi/storageSetup',
        method: 'post',
        data: date
    })
}
//保持存储设置信息
export function setupSave(date) {
    return request({
        url: '/adminapi/setupSave',
        method: 'post',
        data: date
    })
}

// 清空用户脸部信息
export function clearFaceData(date) {
    return request({
        url: '/adminapi/clearFaceData',
        method: 'post',
        data: date
    })
}

// 清空用户卡片信息
export function clearCardData(date) {
    return request({
        url: '/adminapi/clearCardData',
        method: 'post',
        data: date
    })
}

// 单件码列表
export function itemCodeIndex(date) {
    return request({
        url: '/adminapi/itemCodeIndex',
        method: 'post',
        data: date
    })
}

// 保存单件码
export function itemCodeSave(date) {
    return request({
        url: '/adminapi/itemCodeSave',
        method: 'post',
        data: date
    })
}

// 批量导入单件码
export function itemCodeImport(date) {
    return request({
        url: '/adminapi/itemCodeImport',
        method: 'post',
        data: date
    })
}

// 冻结/解冻单件码
export function itemCodeFreeze(date) {
    return request({
        url: '/adminapi/itemCodeFreeze',
        method: 'post',
        data: date
    })
}

// 单件码追溯
export function itemCodeTrace(date) {
    return request({
        url: '/adminapi/itemCodeTrace',
        method: 'post',
        data: date
    })
}

// 单件码事件
export function itemCodeEvents(date) {
    return request({
        url: '/adminapi/itemCodeEvents',
        method: 'post',
        data: date
    })
}
export function previewBoxOutboundTransition(data) {
    return request({ url: '/adminapi/previewBoxOutboundTransition', method: 'post', data });
}

export function commitBoxOutboundTransition(data) {
    return request({ url: '/adminapi/commitBoxOutboundTransition', method: 'post', data });
}

export function previewBoxStockTransition(date) {
    return request({
        url: '/adminapi/previewBoxStockTransition',
        method: 'post',
        data: date
    })
}
export function commitBoxStockTransition(date) {
    return request({
        url: '/adminapi/commitBoxStockTransition',
        method: 'post',
        data: date
    })
}

// 整取零还：读取指定主机构统一开关；不传 oid 时兼容读取当前账号所属主机构
export function wholeTakePartialReturnSetting(params = {}) {
    return request({
        url: '/adminapi/wholeTakePartialReturnSetting',
        method: 'get',
        params
    })
}

// 整取零还：保存主机构统一开关
export function saveWholeTakePartialReturnSetting(date) {
    return request({
        url: '/adminapi/wholeTakePartialReturnSetting',
        method: 'post',
        data: date
    })
}

// 整取零还：读取格包
export function getBoxPackage(date) {
    return request({
        url: '/adminapi/getBoxPackage',
        method: 'get',
        params: date
    })
}

// 整取零还：保存格包定义
export function saveBoxPackage(date) {
    return request({
        url: '/adminapi/saveBoxPackage',
        method: 'post',
        data: date
    })
}

// 整取柜：原格子保存按钮原子保存格子信息和整包商品清单
export function saveWholeTakeBox(date) {
    return request({
        url: '/adminapi/saveWholeTakeBox',
        method: 'post',
        data: date
    })
}

// 整取零还：停用格包
export function disableBoxPackage(date) {
    return request({
        url: '/adminapi/disableBoxPackage',
        method: 'post',
        data: date
    })
}

// 整取零还：准备首次组包或归还后的重新组包会话
export function prepareBoxPackagePacking(date) {
    return request({
        url: '/adminapi/prepareBoxPackagePacking',
        method: 'post',
        data: date
    })
}

// 整取零还：通过专用组包会话打开原格；服务端保证重复请求不重复下发
export function openBoxPackagePacking(date) {
    return request({
        url: '/adminapi/openBoxPackagePacking',
        method: 'post',
        data: date
    })
}

// 整取零还：人工确认 requested 未知态的开格结果
export function resolveBoxPackagePackingDoor(date) {
    return request({
        url: '/adminapi/resolveBoxPackagePackingDoor',
        method: 'post',
        data: date
    })
}

// 整取零还：管理员完成实物核对后确认组包
export function commitBoxPackagePacking(date) {
    return request({
        url: '/adminapi/commitBoxPackagePacking',
        method: 'post',
        data: date
    })
}

// 整取零还：取消未完成的组包会话
export function cancelBoxPackagePacking(date) {
    return request({
        url: '/adminapi/cancelBoxPackagePacking',
        method: 'post',
        data: date
    })
}

// 整取零还：后台组包开格与硬件回执审计记录
export function getBoxPackagePackingRecords(params = {}) {
    return request({
        url: '/adminapi/getBoxPackagePackingRecords',
        method: 'get',
        params
    })
}

// 整取零还：管理员处理单件代还、损坏、缺失、终止与补包
export function handleBoxPackageItem(date) {
    return request({
        url: '/adminapi/handleBoxPackageItem',
        method: 'post',
        data: date
    })
}

// 计数借还柜：确认整机业务模式
export function saveCountingFlowMode(date) {
    return request({
        url: '/adminapi/saveCountingFlowMode',
        method: 'post',
        data: date
    })
}

// 计数借还柜：补货（增量）
export function countingStockOperate(date) {
    return request({
        url: '/adminapi/countingStockOperate',
        method: 'post',
        data: date
    })
}

// 计数借还柜：盘点后按目标库存调整
export function adjustCountingStock(date) {
    return request({
        url: '/adminapi/adjustCountingStock',
        method: 'post',
        data: date
    })
}

// 计数借还柜：按固定动作纠正单条借还记录
export function correctCountingOrder(date) {
    return request({
        url: '/adminapi/correctCountingOrder',
        method: 'post',
        data: date
    })
}
